import { useSharedDisclosure } from "../../../shared/hooks/useSharedDisclosure";

export default function useInviteToCallModal() {
  return useSharedDisclosure({ id: "InviteToCallModal" });
}
